import styled from "styled-components";
import Logo from "./graphics/svv-logo-full_1889x989.png";

const SvvLogo = styled.img.attrs({
  src: Logo,
  alt: "SVV",
  width: 120,
})``;

export default SvvLogo;
